/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext } from "react";
import { useLocation, withRouter } from "react-router";
import { CurrencyContext, UserContext } from "../contexts/AppContext";
import SessionHandler from "../https/SessionHandler";
import Footer from "./components/layouts/Footer";
import { Header } from "./components/layouts/Header";
import { Content } from "./components/layouts/Content";
import { AfriqContainer } from "./components/layouts/AfriqContainer";
import { createStyles, makeStyles } from "@material-ui/core";
//import { CountryPhoneList } from "../utils/CountryList";
import { searchCode, SortArray } from "../utils/App";
import { CountryService } from "./Admin/Countries/services/EquipmentCountry";

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            marginTop: 100,
            background: "#F7F7F7",
            minHeight: "85vh",
            marginRight: "auto",
            marginLeft: "auto",
            maxWidth: 2300,
            [theme.breakpoints.down(1025)]: {
                marginTop: 80
            },
            '& .MuiContainer-maxWidthLg': {
                maxWidth: 1530
            },
        }
    })
);

const excludeFooterComponent = ["/announce"];
const fullWidth = ["/", "/search", "/blog", "/category", "/confirmation-success"];
const countryService = new CountryService();

function Routes() {
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    /*const isConnected = sessionHandler.isConnected;
    const isRefreshed = sessionHandler.isRefreshed; */

    // Use the imported instance directly
    //const { isConnected, isRefreshed } = sessionHandler;
    const userContext = useContext(UserContext);
    const { setUser } = userContext;
    const currencyContext = useContext(CurrencyContext)
    const { setCurrency } = currencyContext
    const location = useLocation();
    const classes = useStyles();
    const [deal, setDeal] = React.useState(false)
    const [paysList, setPaysList] = React.useState<any[]>();

    const handleChangeCloseDealBar = useCallback(() => {
        if (deal) {
            setDeal(false);
        }
    }, [deal]);


    // Memoize the auth check functions
    const checkAuth = useCallback(async () => {
        try {
            const response = await sessionHandler.isConnected();
            if (response?.success && response?.data) {
                setUser(response.data);
                const currency = searchCode(response.data.country, paysList) || "xaf";
                setCurrency(currency);
            }
        } catch (err: any) {
            try {
                const refreshResponse = await sessionHandler.isRefreshed();
                if (refreshResponse?.success && refreshResponse?.user?.data) {
                    setUser(refreshResponse.user.data);
                    setCurrency("xaf");
                }
            } catch (error) {
                setCurrency("xaf");
            }
        }
    }, [sessionHandler, setUser, setCurrency, paysList]);


    React.useEffect(() => {
        let isMounted = true;
        
        const fetchCountries = async () => {
            try {
                const response = await countryService.getAllCountries();
                if (isMounted && response.success && response.data) {
                    setPaysList(response.data.sort(SortArray));
                }
            } catch (error) {
                console.error("Failed to fetch countries", error);
            }
        };

        fetchCountries();
        
        return () => {
            isMounted = false;
        };
    }, []);

    React.useEffect(() => {
        let isMounted = true;
        
        if (paysList && paysList.length > 0) {
            checkAuth().catch(error => {
                console.error("Authentication check failed", error);
                if (isMounted) setCurrency("xaf");
            });
        } else {
            // Fallback currency if paysList not loaded yet
            if (isMounted) setCurrency("xaf");
        }
        
        return () => {
            isMounted = false;
        };
    }, [checkAuth, paysList, setCurrency]);
        

    return (
        <div style={{ background: "rgb(247, 247, 247)" }}>
            <Header setDeal={setDeal} deal={deal} />
            <div className={classes.root} onClick={handleChangeCloseDealBar}>
                {fullWidth.includes(location.pathname) ? (
                    <Content />
                ) : (
                    <AfriqContainer>
                        <Content />
                    </AfriqContainer>
                )}
            </div>
            {!excludeFooterComponent.includes(location.pathname) && <Footer />}
        </div>
    );
}

export default withRouter(Routes);
